





















import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../core/services/crudService";
import { Settings, SettingsService } from "../core/services/configService";
import { ProgramPackTexts } from "./programPackTexts";
import ProgramPage from "../components/programs/ProgramPage.vue";
import ProgramHero from "../components/programs/ProgramHero.vue";
import ProgramMeta from "../components/programs/ProgramMeta.vue";
import ProgramMedia from "../components/programs/ProgramMedia.vue";
import ProgramPanel from "../components/programs/ProgramPanel.vue";
import ProgramColumns from "../components/programs/ProgramColumns.vue";

@Component({
  components: { ProgramPage, ProgramHero, ProgramMeta, ProgramMedia, ProgramPanel, ProgramColumns },
})
export default class ProgramPackPage extends Vue {
  program: any = null;
  loaded: boolean = false;
  texts = ProgramPackTexts;

  get emptyText(): string {
    return this.loaded && this.program === null ? this.$t("This program is not available").toString() : "";
  }

  get facts(): string[] {
    const p = this.program;
    return [
      ProgramPackTexts.price(this.t, p),
      ProgramPackTexts.installments(this.t, p, true),
      ProgramPackTexts.cancellation(this.t, p),
      ProgramPackTexts.startDays(this.t, p),
      ProgramPackTexts.completion(this.t, p),
    ];
  }

  get columns(): any[] {
    return this.program.columns.map((col: any, i: number) => ({
      name: col.name,
      when: ProgramPackTexts.columnWhen(this.t, this.program, col, i),
      rows: col.cards
        .filter((k: any) => k.cardType === 0 && !k.isOptional)
        .map((k: any) => ({ name: ProgramPackTexts.cardName(k), detail: ProgramPackTexts.cardDetail(this.t, k) })),
    }));
  }

  get items(): string[] {
    return ProgramPackTexts.itemNames(this.program);
  }

  get upgrades(): any[] {
    return ProgramPackTexts.cards(this.program, 0, true)
      .concat(ProgramPackTexts.cards(this.program, 1, true))
      .map((k: any) => ({
        name: ProgramPackTexts.cardName(k),
        detail: [ProgramPackTexts.cardDetail(this.t, k), "+" + ProgramPackTexts.money(k.price)].filter((x) => x).join(" · "),
      }));
  }

  t(key: string): string {
    return this.$t(key).toString();
  }

  async mounted() {
    const data = await new CrudService().httpGet(`${Settings.HostName}/api/publicprogrampacks/${this.$route.params.id}`);
    this.program = data && data.ok ? data.model : null;
    this.loaded = true;
    if (this.program) {
      new SettingsService().setPageTitle(this.program.name);
    }
  }
}
